import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Modal, Button, Popconfirm } from 'antd';
import AddKRForm from './add_kr_form';

class AddKR extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }

  krFormRef = (form) => {
    this.krForm = form
  }

  handelCreateKr = () => {
    const form = this.krForm;
    form.validateFields((err, values) => {
      console.log('handelCreateKr:::', values);
      if (err) {
        return
      }
      const { title, description, metric, weightE2, startValue, endValue, unit, oid } = values;
      const params = {
        title,
        description,
        metric,
        startValue,
        endValue,
        unit,
        oid,
        weightE2
      }

      if (this.props.handleOk) {
        this.props.handleOk(params);
        form.resetFields();
      }
    });
  }

  handleCancelCreate = () => {
    const form = this.krForm;
    form.resetFields();
    if (this.props.handleCancel) {
      this.props.handleCancel();
    }
  }
  handleDelete = () => {
    if (this.props.handleDelete) {
      this.props.handleDelete(this.props.kr.kid);
    }
  }
  render() {
    const { visible, objective, kr } = this.props;
    const footerHandle = () => {
      console.log('footerHandle');
      if (kr && kr.kid) {
        return [
          <Popconfirm key="delete" title="确认要删除吗?" onConfirm={this.handleDelete} okText="确定" cancelText="取消">
            <Button size="large">删除</Button>
          </Popconfirm>,
          <Button key="submit" type="primary" size="large" onClick={this.handelCreateKr}>{kr.kid ? "保存" : "新建"}</Button>
        ]
      }
      else {
        return [
          <Button key="delete" size="large" onClick={this.handleCancelCreate}>取消</Button>,
          <Button key="submit" type="primary" size="large" onClick={this.handelCreateKr}>{kr.kid ? "保存" : "新建"}</Button>
        ]
      }
    }
    return (
      <Modal
        title={kr && kr.kid ? "编辑Key Result" : "添加Key Result"}
        visible={visible}
        onOk={this.handelCreateKr}
        onCancel={this.handleCancelCreate}
        footer={footerHandle()}
      >
        <AddKRForm
          ref={this.krFormRef}
          objective={objective}
          kr={kr}
          visible={visible}
        />
      </Modal>
    )
  }
}

function mapStateToProps({ page }) {
  return {}
}


export default connect(mapStateToProps)(AddKR);


// WEBPACK FOOTER //
// ./src/components/okr_manage/add_kr.js